import { memo } from "react";
import { DialogContent } from "@mui/material";

import RegisterForm from "components/auth/RegisterForm";
import ClosableDialog from "components/shared/ClosableDialog";
import useDialog from "hooks/useDialog";

const RegisterDialog: React.FC = () => {
  const { openRegisterDialog, setOpenRegisterDialog } = useDialog();

  return (
    <ClosableDialog
      open={openRegisterDialog}
      onClose={() => setOpenRegisterDialog(false)}
    >
      <DialogContent>
        <RegisterForm />
      </DialogContent>
    </ClosableDialog>
  );
};

export default memo(RegisterDialog);
